// Configurazione dell'applicazione
export const APP_CONFIG = {
    // Modalità di sviluppo
    DEVELOPMENT: {
        ENABLE_CONSOLE_LOGS: import.meta.env.VITE_ENABLE_CONSOLE_LOGS === 'true' || import.meta.env.DEV,
        ENABLE_TEST_MODE: import.meta.env.VITE_ENABLE_TEST_MODE === 'true',
        ENABLE_DEBUG_FORMS: import.meta.env.VITE_ENABLE_DEBUG_FORMS === 'true' || import.meta.env.DEV
    },
    
    // Configurazioni API
    API: {
        TIMEOUT: 30000,
        RETRY_ATTEMPTS: 3
    },
    
    // Configurazioni UI
    UI: {
        PRELOADER_DURATION: 2000,
        ANIMATION_DURATION: 700,
        TOAST_DURATION: 5000
    }
};

// Helper per logging condizionale
export const logger = {
    log: (...args) => {
        if (APP_CONFIG.DEVELOPMENT.ENABLE_CONSOLE_LOGS) {
            console.log(...args);
        }
    },
    warn: (...args) => {
        if (APP_CONFIG.DEVELOPMENT.ENABLE_CONSOLE_LOGS) {
            console.warn(...args);
        }
    },
    error: (...args) => {
        console.error(...args);
    }
};
